import { useState } from 'react'
import { GoogleLogin } from '@react-oauth/google'
import { useMutation } from '@apollo/client/react'
import { Text, Center } from '@mantine/core'
import LoginWithGoogle from '../graphql/queries/LoginWithGoogle'
import CurrentUser from '../graphql/queries/CurrentUser'
import { Actions } from '../AppReducer'
import { useAppDispatch } from '../AppContext'

export default function GoogleLoginButton({ onClose, roomId }) {
    const dispatch = useAppDispatch()
    const [errorMessage, setErrorMessage] = useState('')

    const [loginWithGoogle] = useMutation(LoginWithGoogle, {
        fetchPolicy: 'no-cache',
        update: (cache, { data }) => {
            if (data?.loginWithGoogle) {
                cache.writeQuery({
                    query: CurrentUser,
                    data: data.loginWithGoogle
                })
            }
        }
    })

    async function handleSuccess(credentialResponse) {
        // credentialResponse.credential is the id_token JWT — this is the correct
        // way to get an id_token from @react-oauth/google. The old useGoogleLogin
        // hook with flow: 'implicit' uses Google's token client, which only ever
        // returns an access_token, never an id_token.
        const idToken = credentialResponse.credential
        if (!idToken) {
            setErrorMessage('Google sign-in failed. Please try again.')
            return
        }
        try {
            const { data } = await loginWithGoogle({ variables: { idToken } })
            if (data?.loginWithGoogle?.accessToken) {
                const { accessToken, refreshToken } = data.loginWithGoogle
                localStorage.setItem('at', accessToken)
                if (refreshToken) localStorage.setItem('rt', refreshToken)
                dispatch(Actions.logIn())
                if (roomId) dispatch(Actions.setCurrentRoom(roomId))
                onClose?.()
            }
        } catch (err) {
            console.error('Google login error:', err)
            setErrorMessage('Google sign-in failed. Please try again.')
        }
    }

    function handleError() {
        setErrorMessage('Google sign-in failed. Please try again.')
    }

    return (
        <>
            <Center>
                <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={handleError}
                    shape="rectangular"
                    theme="filled_black"
                    text="continue_with"
                    size="large"
                    width={224}
                    containerProps={{
                        style: {
                            backgroundColor: '#202124',
                            borderRadius: '4px',
                            overflow: 'hidden',
                        }
                    }}
                />
            </Center>
            {errorMessage && (
                <Text size="sm" c="red" ta="center" mt="xs">{errorMessage}</Text>
            )}
        </>
    )
}
